import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserGroupUseRights = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15C12.0609 15 13.0783 15.4214 13.8284 16.1716C14.5786 16.9217 15 17.9391 15 19V21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 3.12988C15.8604 3.35018 16.623 3.85058 17.1676 4.55219C17.7122 5.2538 18.0078 6.11671 18.0078 7.00488C18.0078 7.89305 17.7122 8.75596 17.1676 9.45757C16.623 10.1592 15.8604 10.6596 15 10.8799",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 20.9999V18.9999C19.9949 18.1171 19.6979 17.2607 19.1553 16.5643C18.6126 15.8679 17.8548 15.3706 17 15.1499",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.49997 18.5C5.71506 18.5 5.88942 18.3259 5.88942 18.1111C5.88942 17.8963 5.71506 17.7222 5.49997 17.7222C5.28489 17.7222 5.11053 17.8963 5.11053 18.1111C5.11053 18.3259 5.28489 18.5 5.49997 18.5ZM5.49997 18.5L5.49997 19.4722M5.5 15C6.40968 15.8037 7.59696 16.2221 8.81029 16.1667C8.98694 16.7667 9.04099 17.3961 8.96923 18.0175C8.89747 18.6388 8.70137 19.2394 8.39257 19.7835C8.08377 20.3277 7.66858 20.8043 7.17168 21.1851C6.67477 21.5658 6.10628 21.843 5.5 22C4.89372 21.843 4.32523 21.5658 3.82832 21.1851C3.33142 20.8043 2.91623 20.3277 2.60743 19.7835C2.29863 19.2394 2.10253 18.6388 2.03077 18.0175C1.95901 17.3961 2.01306 16.7667 2.18971 16.1667C3.40304 16.2221 4.59032 15.8037 5.5 15Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUserGroupUseRights;
